import React, { useMemo } from 'react';
import { isToday, isYesterday, isWithinInterval, subDays, startOfDay } from 'date-fns';
import ChatItem from './ChatItem';
import './ChatGroup.css';

/**
 * Groups chats by date: Today, Yesterday, Previous 7 Days, Older
 */
const ChatGroup = ({
  chats,
  selectedChatId,
  onChatSelect,
  instruments,
  onDeleteChat
}) => {
  const groupedChats = useMemo(() => {
    const today = startOfDay(new Date());
    const yesterday = subDays(today, 1);
    const weekAgo = subDays(today, 7);

    const groups = {
      today: [],
      yesterday: [],
      previousWeek: [],
      older: []
    };

    chats.forEach(chat => {
      const chatDate = new Date(chat.updated_at);

      if (isNaN(chatDate.getTime())) {
        groups.older.push(chat);
        return;
      }

      if (isToday(chatDate)) {
        groups.today.push(chat);
      } else if (isYesterday(chatDate)) {
        groups.yesterday.push(chat);
      } else if (isWithinInterval(chatDate, { start: weekAgo, end: yesterday })) {
        groups.previousWeek.push(chat);
      } else {
        groups.older.push(chat);
      }
    });

    return groups;
  }, [chats]);

  const renderGroup = (title, chatList) => {
    if (chatList.length === 0) return null;

    return (
      <div className="chat-group" key={title}>
        <h3 className="chat-group-header">{title}</h3>
        <div className="chat-group-items">
          {chatList.map(chat => (
            <ChatItem
              key={chat.chat_id}
              chat={{ ...chat, onDelete: onDeleteChat }}
              isSelected={selectedChatId === chat.chat_id}
              onChatSelect={onChatSelect}
              instruments={instruments}
            />
          ))}
        </div>
      </div>
    );
  };

  const hasNoChats =
    groupedChats.today.length === 0 &&
    groupedChats.yesterday.length === 0 &&
    groupedChats.previousWeek.length === 0 &&
    groupedChats.older.length === 0;

  if (hasNoChats) {
    return (
      <div className="chat-group-empty">
        <div className="chat-group-empty-icon">📊</div>
        <div className="chat-group-empty-title">No instrument chats yet</div>
        <div className="chat-group-empty-text">
          Select an instrument from the header to start a conversation
        </div>
      </div>
    );
  }

  return (
    <div className="chat-groups">
      {renderGroup('Today', groupedChats.today)}
      {renderGroup('Yesterday', groupedChats.yesterday)}
      {renderGroup('Previous 7 Days', groupedChats.previousWeek)}
      {renderGroup('Older', groupedChats.older)}
    </div>
  );
};

export default ChatGroup;
